// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'
import VeeValidate from 'vee-validate'
import { truncate } from 'lodash'
import EventBus from './plugins/event-bus'

import VueFriendlyIframe from 'vue-friendly-iframe'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)
Vue.filter('currency', function (value) {
  return 'R$' + parseFloat(value).toFixed(2)
})

Vue.filter('twoDigits', (value) => {
  if (value.toString().length <= 1) {
    return '0' + value.toString()
  }
  return value.toString()
})
Vue.filter('capitalize', function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
})
Vue.filter('lowercase', function (str) {
  return str.charAt(0).toLowerCase() + str.slice(1)
})
Vue.filter('firstChar', function (str) {
  return str.charAt(0).toUpperCase()
})
Vue.filter('first2Char', function (str) {
  return str.substring(0, 2).toUpperCase()
})
Vue.filter('hljshtml', function (value) {
  return value.replace(/</g, '&lt;').replace(/>/g, '&gt;')
})

Vue.filter('truncate', function (value, args) {
  return truncate(value, args)
})

const config = {
  errorBagName: 'errors', // change if property conflicts
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  classes: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true,
  validity: false,
  aria: true,
  i18n: null, // the vue-i18n plugin instance,
  i18nRootKey: 'validations' // the nested key under which the validation messsages will be located
}

Vue.use(VeeValidate, config)
Vue.use(EventBus)

Vue.use(Vuetify, {
  theme: {
    primary: '#3f51b5',
    secondary: '#b0bec5',
    accent: '#8c9eff',
    error: '#b71c1c'
  }
})

// const instance = axios.create({
//   baseURL: 'https://some-domain.com/api/',
//   timeout: 1000,
//   headers: {'X-Custom-Header': 'foobar'}
// })

axios.create({
  baseURL: `${process.env.URL}`
})
window.axios = axios
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.post['authorization'] = 'kpNzqXieqb4nXnlC2bdZRZE8xafzmV'

Vue.use(VueAxios, axios)

Vue.use(VueFriendlyIframe)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js